import { graphql } from "../gql";

export const getThreadsQueryDoc = graphql(`
  query getThreads($input: ThreadsInput!) {
    threads(input: $input) {
      ...ThreadFragment
    }
  }
`);
